import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {

  },
  actions: {
    async fetchDebt({ commit, state }) {

     if (state.data)
       return;

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/user/debt/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    debt: state => state.data,
    debtLoading: state => state.loading,
    debtError: state => state.error,
    debtLoaded: state => state.loaded,
  }
})